var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-input__font",style:({ fontWeight: _vm.weight })},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }